/** Color for a "points" value relative to the criterion's maxScore, for quick visual scanning of rule tables. */
export function pointsColor(points, maxScore) {
    if (points === null || points === undefined || points === "") return "gray.500";
    const value = Number(points);
    if (value <= 0) return "red.600";
    if (!maxScore || Number(maxScore) <= 0) return "gray.900";
    const ratio = value / Number(maxScore);
    if (ratio < 1 / 3) return "red.600";
    if (ratio < 2 / 3) return "orange.600";
    return "green.600";
}
